import { Component, Inject } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CondoUser } from '@api/model/condo-user';
import { UserService } from '@api/service/user.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-edit-email',
  templateUrl: './modal-edit-email.component.html',
  styleUrls: ['./modal-edit-email.component.scss']
})
export class ModalEditEmailComponent {
  user: CondoUser;
  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private notification: NzNotificationService,
    @Inject(NZ_MODAL_DATA) data: { user: CondoUser }
  ) {
    this.user = data.user;
    this.form = this.fb.group({
      email: new UntypedFormControl(null, [Validators.required, Validators.email])
    });
  }

  submitForm(): void {
    if (this.form.valid) {
      this.userService.updateUser(this.user?._id, { email: this.form.value.email }).subscribe({
        next: res => {
          this.notification.create('success', 'Email', 'Email Alterado');
          this.user.email = this.form.value.email;
        },
        error: error => {
          this.notification.create('error', 'Email', 'Erro ao alterar email');
        }
      });
    }
  }
}
